import { render, staticRenderFns } from "./MicrosoftSignIn.vue?vue&type=template&id=fe8435d6&scoped=true&lang=html"
import script from "./MicrosoftSignIn.vue?vue&type=script&lang=js"
export * from "./MicrosoftSignIn.vue?vue&type=script&lang=js"
import style0 from "./MicrosoftSignIn.vue?vue&type=style&index=0&id=fe8435d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8435d6",
  null
  
)

export default component.exports